import { ParkingCandidate } from 'services/ParkingAgentService';

export interface RecoverySelection {
  candidates: ParkingCandidate[];
  sourceHash: string;
}

export const RECOVERY_CSV_HEADER =
  'X,Y,Z,Layer,PaperSpace,SubClasses,Linetype,EntityHandle,Text,OGR_STYLE,IsPoint';

/** Keep the source meter coordinates and explicit closed rings for the existing CSV importer. */
export function recoveryCsv(
  candidates: ParkingCandidate[],
  sourceHash: string,
  coordinateOffset: [number, number] = [0, 0],
): File {
  const rows = [RECOVERY_CSV_HEADER];
  for (const candidate of candidates) {
    const layer = candidate.parking_type ?? 'p-parking-basic';
    for (const [x, y] of candidate.vertices) {
      rows.push(
        `${(x - coordinateOffset[0]).toFixed(6)},${(
          y - coordinateOffset[1]
        ).toFixed(
          6,
        )},0,${layer},0,AcDbEntity:AcDbPolyline,,recovery-${sourceHash.slice(
          0,
          12,
        )}-${candidate.id},,,false`,
      );
    }
  }
  return new File([rows.join('\n')], 'parking-recovery-candidates.csv', {
    type: 'text/csv',
  });
}
